import { render, staticRenderFns } from "./ProjectBar.vue?vue&type=template&id=65785448&lang=pug&"
import script from "./ProjectBar.vue?vue&type=script&lang=js&"
export * from "./ProjectBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports